import React, { useEffect, useState } from 'react'
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import { CForm, CFormLabel, CFormInput, CSpinner, CButton, CRow, CCol, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormTextarea, CNav, CNavItem, CNavLink, CTabContent, CTabPane } from '@coreui/react'
import Select from 'react-select'
import LabCRUD from '../../services/general/LabsAPI.api.js'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Pageloader from '../../components/shared/Pageloader'
import DiagnosisDetails from './DiagnosisDetails'
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info } from 'lucide-react'
import ReasonSuggestion from './ReasonSuggestion'
import ListView from '../../components/shared/ListView'
import CloudinaryUploader from '../../components/shared/CloudinaryUploader'
import { SaveActivity } from './save-activity'
import { Plus } from 'lucide-react'

const LabMaster = () => {
  const [labName, setLabName] = useState('')
  const [showRequired, setShowRequired] = useState(false)
  const [unit, setUnit] = useState('')
  const [rangeMax, setRangeMax] = useState('')
  const [rangeMin, setRangeMin] = useState('')
  const [modalVisible, setModalVisible] = useState(false)
  const [labList, setLabList] = useState([])
  const [isDataRefetched, setDataRefetched] = useState(false)
  const [loading, setLoading] = useState(true) // Added loading state
  const [editIndex, setEditIndex] = useState(null) // Added state to track the index of the lab being edited
  const buttonList = [{ Name: 'Edit' }, { Name: 'Delete' }]
  const [allDiagnoses, setAllDiagnoses] = useState([])
  // Example options, replace with your data
  const [selectedDiagnosesLow, setSelectedDiagnosesLow] = useState([])
  const [remarkLow, setRemarkLow] = useState('')
  const [remarkLowPlan, setRemarkLowPlan] = useState('')
  const [boxView, setBoxView] = useState('list')
  const [selectedDiagnosesNormal, setSelectedDiagnosesNormal] = useState([])
  const [remarkNormal, setRemarkNormal] = useState('')
  const [remarkNormalPlan, setRemarkNormalPlan] = useState('')
  const [selectedDiagnosesHigh, setSelectedDiagnosesHigh] = useState([])
  const [remarkHigh, setRemarkHigh] = useState('')
  const [remarkHighPlan, setRemarkHighPlan] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const [labImageName, setLabImage] = useState(null)
  const [file, setFile] = useState([])

  const [reasonEntries, setReasonEntries] = useState([])
  const [codeEntries, setCodeEntries] = useState([])
  const [reasonInput, setReasonInput] = useState('')
  const [codeInput, setCodeInput] = useState('')

  const addReasonEntry = () => {
    const trimmed = reasonInput.trim()
    if (!trimmed) return
    setReasonEntries((prev) => [...prev, trimmed])
    setReasonInput('')
  }

  const addCodeEntry = () => {
    const trimmed = codeInput.trim()
    if (!trimmed) return
    setCodeEntries((prev) => [...prev, trimmed])
    setCodeInput('')
  }

  const removeReasonEntry = (index) => {
    setReasonEntries((prev) => prev.filter((_, i) => i !== index))
  }

  const removeCodeEntry = (index) => {
    setCodeEntries((prev) => prev.filter((_, i) => i !== index))
  }

  const handleOnClick = (type, e) => {
    if (type == 'EDIT') {
      handleEditLab(e)
    } else if (type == 'DELETE') {
      setDeleteVisibleId(e)
    }
  }

  const setDiagnosis = (diagnosis) => {
    let newDiagnosis = allDiagnoses.find((d) => {
      if (d.label.trim() == diagnosis) return d
    })
    return newDiagnosis
  }
  const handleDeleteLab = async (e) => {
    let labData = await LabCRUD('DELETE', '{}', deleteVisibleId?.ID.toString())
    await handleLabData()
    setDeleteVisibleId(null)
    SaveActivity('Deleted Master Labs')
  }

  const fetchDiagnoses = async () => {
    try {
      setLoading(true)

      const response = await GetDiagnosisData()
      const data = JSON.parse(response.d)
      setAllDiagnoses(data.Data.map((diagnosis) => ({ value: diagnosis.id, label: diagnosis.Name })))
    } catch (error) {
      console.error('Error fetching diagnoses:', error)
    }
    setLoading(false) // Data fetching complete, stop the spinner
  }

  const handleLabData = async () => {
    setIsPageLoading(true)
    try {
      let labData = await LabCRUD('GETALL', '{}')
      labData = JSON.parse(labData.d)?.Data
      // Simulate fetching data
      setLabList(labData)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false) // Data fetching complete, stop the spinner
    }
  }

  useEffect(() => {
    fetchDiagnoses()
    handleLabData()
  }, [])

  const handleAddLab = () => {
    setShowRequired(false)
    setLabName('')
    setUnit('')
    setRangeMax('')
    setRangeMin('')
    setSelectedDiagnosesLow([])
    setRemarkLow('')
    setRemarkLowPlan('')
    setSelectedDiagnosesNormal([])
    setRemarkNormal('')
    setRemarkNormalPlan('')
    setSelectedDiagnosesHigh([])
    setRemarkHigh('')
    setRemarkHighPlan('')
    setEditIndex(null)
    setModalVisible(true)
    setReasonEntries([])
    setCodeEntries([])
    setReasonInput('')
    setCodeInput('')
  }

  const handleEditLab = (lab) => {
    setShowRequired(false)
    setLabName(lab?.LabName)
    setUnit(lab?.Unit)
    setRangeMax(lab?.RangeMax)
    setRangeMin(lab?.RangeMin)
    let lowDiagnosis = lab?.DiagnosesLow.split(',') || []
    lowDiagnosis = lowDiagnosis.map((e) => {
      return setDiagnosis(e)
    })
    let normalDiagnosis = lab?.DiagnosesNormal.split(',') || []
    normalDiagnosis = normalDiagnosis.map((e) => {
      console.log(e)
      return setDiagnosis(e.trim())
    })
    let highDiagnosis = lab?.DiagnosesHigh.split(',') || []
    highDiagnosis = highDiagnosis.map((e) => {
      console.log(e)
      return setDiagnosis(e.trim())
    })

    setSelectedDiagnosesLow(lowDiagnosis)
    setRemarkLow(lab?.RemarkLow || '')
    setRemarkLowPlan(lab?.RemarkPlanLow || '')
    setSelectedDiagnosesNormal(normalDiagnosis)
    setRemarkNormal(lab?.RemarkNormal || '')
    setRemarkNormalPlan(lab?.RemarkPlanNormal || '')
    setSelectedDiagnosesHigh(highDiagnosis)
    setRemarkHigh(lab?.RemarkHigh || '')
    setRemarkHighPlan(lab?.RemarkPlanHigh || '')
    setEditIndex(lab?.ID) // Track the index of the lab being edited
    setModalVisible(true)

    try {
      setFile(lab?.ExtraData ? JSON.parse(lab.ExtraData) : [])
    }
    catch {
      setFile([])
    }

    const rawReasonList = lab?.ReasonList || lab?.reasonList || '[]'
    let parsedReasonList = []
    try {
      parsedReasonList = typeof rawReasonList === 'string' ? JSON.parse(rawReasonList) : rawReasonList
    } catch (err) {
      parsedReasonList = []
    }
    // Load Reasons
    let parsedReasons = []
    try {
      parsedReasons = lab?.LabReason
        ? JSON.parse(lab.LabReason)
        : []
    } catch {
      parsedReasons = []
    }

    try {
      const reasons = JSON.parse(lab?.LabReason || '[]')
      setReasonEntries(
        Array.isArray(reasons)
          ? reasons.map(x => x.reason).filter(Boolean)
          : []
      )
    }
    catch {
      setReasonEntries([])
    }


    try {
      const codes = JSON.parse(lab?.LabCode || '[]')
      setCodeEntries(
        Array.isArray(codes)
          ? codes.map(x => x.code).filter(Boolean)
          : []
      )
    }
    catch {
      setCodeEntries([])
    }


    setReasonInput('')
    setCodeInput('')
  }

  const handleSaveLab = async () => {
    if ([labName, unit, rangeMin, rangeMax].some((value) => !String(value ?? '').trim())) { setShowRequired(true); setActiveTab(0); return }
    setShowRequired(false)
    setIsLoading(true)

    try {

      const newLab = {
        LabName: labName,
        Unit: unit,
        RangeMax: rangeMax,
        RangeMin: rangeMin,
        DiagnosesLow: selectedDiagnosesLow?.map((d) => d?.label?.trim()).join(','),
        RemarkLow: remarkLow,
        RemarkPlanLow: remarkLowPlan,
        DiagnosesNormal: selectedDiagnosesNormal?.map((d) => d?.label?.trim()).join(','),
        RemarkNormal: remarkNormal,
        RemarkPlanNormal: remarkNormalPlan,
        DiagnosesHigh: selectedDiagnosesHigh?.map((d) => d?.label?.trim()).join(','),
        RemarkHigh: remarkHigh,
        RemarkPlanHigh: remarkHighPlan,
        LabReason: JSON.stringify(
          reasonEntries.map((reason) => ({
            reason: reason
          }))
        ),

        LabCode: ''
        ,
        ExtraData: JSON.stringify(file),
      }
      if (editIndex) {
        await LabCRUD('UPDATE', JSON.stringify(newLab), editIndex.toString())
        SaveActivity('Updated Master Labs')
      } else {
        await LabCRUD('INSERT', JSON.stringify(newLab))
        SaveActivity('Insert Master Labs')
      }

      await handleLabData()

      setModalVisible(false)
      setLabName('')
      setUnit('')
      setRangeMax('')
      setRangeMin('')
      setSelectedDiagnosesLow([])
      setRemarkLow('')
      setRemarkLowPlan('')
      setSelectedDiagnosesNormal([])
      setRemarkNormal('')
      setRemarkNormalPlan('')
      setSelectedDiagnosesHigh([])
      setRemarkHigh('')
      setRemarkHighPlan('')
      setEditIndex(null)
      setFile([])
      setReasonEntries([])
      setCodeEntries([])
      setReasonInput('')
      setCodeInput('')
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }
  const handleDeleteFile = (id) => {
    setFile((prevFiles) => {
      if (prevFiles.length === 1) return []
      return prevFiles.filter((item, i) => item.id !== id)
    })
  }

  const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {
    setFile((prevFiles) => {
      const isDuplicate = prevFiles.some((file) => file.url === url)

      if (isDuplicate) return prevFiles

      return [...prevFiles, { url, type, fileName, id, publicId }]
    })
  }
  return (
    <>
      <div className={`position-relative patient-theme-page lab-master-theme ${boxView === 'list' ? 'lab-master-theme--list' : 'lab-master-theme--box'}`}>
        <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme">
          <CCard className="m-2 master-grid-theme__toolbar">
            <CCardBody className="w-100 master-grid-theme__toolbar-body">
              <div className="d-flex align-items-center justify-content-between w-100">
                <div className="w-100">
                  <CButton className="ui-action-btn ui-action-btn--primary" onClick={handleAddLab}>
                    + Add Lab
                  </CButton>
                </div>
                <span className="d-flex align-items-center gap-1 w">
                  <button
                    type="button"
                    onClick={() => {
                      setBoxView('list')
                    }}
                    className={`patient-theme-view-toggle appointment-view-toggle ${boxView === 'list' ? 'patient-theme-view-toggle--active' : ''}`}
                  >
                    List
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setBoxView('box')
                    }}
                    className={`patient-theme-view-toggle appointment-view-toggle ${boxView === 'box' ? 'patient-theme-view-toggle--active' : ''}`}
                  >
                    Box
                  </button>
                </span>
                <CCol>{loading && <CSpinner />}</CCol>
              </div>
            </CCardBody>
          </CCard>

          {boxView === 'list' && (
  <CustomAgGrid
    className="lab-master-theme__grid"
    rowClickedFn={(type, row) => {
      const fullLab = labList.find(
        (lab) => String(lab.ID) === String(row?.ID)
      )

      if (!fullLab) return

      if (type === 'DELETE') {
        handleOnClick('DELETE', fullLab)
      } else {
        handleOnClick('EDIT', fullLab)
      }
    }}
    callFrom="Lab"
    options={labList.map(({ ReasonList, ExtraData, ...rest }) => rest)}
    btnList={buttonList}
  />
)}

          {boxView === 'box' && (
            <CRow className="p-2 m-2 py-4 master-grid-theme__box-list">
              {labList.map((lab, index) => {
                return (
                  <CCol xs="12" md="6" lg="4" key={index}>
                    <ListView
                      editFunc={() => handleOnClick('EDIT', lab)}
                      // viewFunc={()=>handleOnClick("EDIT",lab)}
                      deletePEFunc={() => {
                        setDeleteVisibleId({ ID: lab?.ID })
                      }}
                      showMatch={false}
                      heading={lab?.LabName}
                    />
                  </CCol>
                )
              })}
            </CRow>
          )}

          <CModal className="patient-theme-modal lab-master-theme__modal" size="xl" scrollable backdrop={'static'} visible={modalVisible} onClose={() => setModalVisible(false)}>
            <CModalHeader onClose={() => setModalVisible(false)}>
              <CModalTitle>{editIndex !== null ? 'Edit Lab' : 'Add Lab'}</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <CForm>
                <div className="pe-tab-underline-nav mb-4">
                  <CNav role="tablist" className="justify-content-center">
                    <CNavItem>
                      <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                        Details
                      </CNavLink>
                    </CNavItem>

                    <CNavItem>
                      <CNavLink active={activeTab === 2} onClick={() => setActiveTab(2)}>
                        Image
                      </CNavLink>
                    </CNavItem>
                  </CNav>
                </div>
                <CTabContent activeTab={activeTab}>
                  <CTabPane visible={activeTab === 0}>
                    <div>
                      <CRow className="mb-3">
                        <CCol xs="6">
                          <CFormLabel>Lab Name <span className="text-danger">*</span></CFormLabel>
                          <CFormInput type="text" id="labName" placeholder="Enter lab name" value={labName} onChange={(e) => setLabName(e.target.value)} />
                          {showRequired && !labName?.trim() && <div className="text-danger small mt-1" role="alert">Lab name is required.</div>}
                        </CCol>
                        <CCol xs="6">
                          <CFormLabel>Unit <span className="text-danger">*</span></CFormLabel>
                          <CFormInput type="text" id="unit" placeholder="Enter unit" value={unit} onChange={(e) => setUnit(e.target.value)} />
                          {showRequired && !String(unit ?? '').trim() && <div className="text-danger small mt-1" role="alert">Unit is required.</div>}
                        </CCol>
                      </CRow>
                      <CRow className="mb-3">
                        <CCol xs="6">
                          <CFormLabel>Range Min <span className="text-danger">*</span></CFormLabel>
                          <CFormInput type="number" id="rangeMin" placeholder="Enter range min" value={rangeMin} onChange={(e) => setRangeMin(e.target.value)} />
                          {showRequired && !String(rangeMin ?? '').trim() && <div className="text-danger small mt-1" role="alert">Range min is required.</div>}
                        </CCol>
                        <CCol xs="6">
                          <CFormLabel>Range Max <span className="text-danger">*</span></CFormLabel>
                          <CFormInput type="number" id="rangeMax" placeholder="Enter range max" value={rangeMax} onChange={(e) => setRangeMax(e.target.value)} />
                          {showRequired && !String(rangeMax ?? '').trim() && <div className="text-danger small mt-1" role="alert">Range max is required.</div>}
                        </CCol>
                      </CRow>
                      <CCol md={12}>
                        <hr />
                      </CCol>
                      {/* Reason */}
                      <CRow className="mb-3">
                        <CCol xs="12">
                          <div className="d-flex align-items-end gap-3">
                            <div className="flex-grow-1">
                              <CFormLabel>Reason</CFormLabel>
                              <CFormInput
                                type="text"
                                placeholder="Enter reason"
                                value={reasonInput}
                                onChange={(e) => setReasonInput(e.target.value)}
                              />
                            </div>



                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                width: '42px',
                                height: '38px',
                                cursor: 'pointer',
                                border: '1px solid #495057',
                                borderRadius: '0.375rem',
                                background: 'transparent',
                              }}
                              onClick={addReasonEntry}
                            >
                              <Plus
                                className="text-white"
                                strokeWidth={2}
                                size={24}
                              />
                            </div>
                          </div>
                        </CCol>
                      </CRow>

                      {/* Added Reasons */}
                      {reasonEntries.length > 0 && (
                        <CRow className="mb-3">
                          <CCol xs="12">
                            <CFormLabel>Added Reasons</CFormLabel>

                            <div
                              className="form-control d-flex flex-wrap align-items-center gap-2"
                              style={{
                                minHeight: "48px",
                                background: "#1f1f1f",
                                borderColor: "#495057",
                              }}
                            >
                              {reasonEntries.map((reason, index) => (
                                <span
                                  key={index}
                                  className="badge  d-flex align-items-center"
                                  style={{
                                    background: "#2c3e50",
                                    fontSize: "13px",
                                    padding: "6px 10px",
                                  }}
                                >
                                  {reason}

                                  <button
                                    type="button"
                                    className="btn-close btn-close-white ms-2"
                                    style={{ fontSize: "8px" }}
                                    onClick={() => removeReasonEntry(index)}
                                  />
                                </span>
                              ))}
                            </div>
                          </CCol>
                        </CRow>
                      )}
                      {/* Code */}
                      {/* <CRow className="mb-3">
  <CCol xs="12">
    <div className="d-flex align-items-end gap-3">
      <div className="flex-grow-1">
        <CFormLabel>Code</CFormLabel>
        <CFormInput
          type="text"
          placeholder="Enter code"
          value={codeInput}
          onChange={(e) => setCodeInput(e.target.value)}
        />
      </div>
     <div
  className="d-flex align-items-center justify-content-center"
  style={{
    width: '42px',
    height: '38px',
    cursor: 'pointer',   
    border: '1px solid #495057',
    borderRadius: '0.375rem',
    background: 'transparent',
  }}
  onClick={addCodeEntry}
>
  <Plus
    className="text-white"
    strokeWidth={2}
    size={24}
  />
</div>

      {/* <CButton className="d-flex align-items-center" color="primary" size="sm" onClick={addCodeEntry}>
        +        
      </CButton> */}
                      {/* </div>
  </CCol>
</CRow> */}


                      {/* {codeEntries.length > 0 && (
  <CRow className="mb-3">
    <CCol xs="12">
      <CFormLabel>Added Codes</CFormLabel>

      <div
        className="form-control d-flex flex-wrap align-items-center gap-2"
        style={{
          minHeight: "48px",
          background: "#1f1f1f",
          borderColor: "#495057",
        }}
      >
        {codeEntries.map((code, index) => (
          <span
            key={index}
            className="badge  d-flex align-items-center"
            style={{
              background:"#2c3e50",
              fontSize: "13px",
              padding: "6px 10px",
            }}
          >
            {code}

            <button
              type="button"
              className="btn-close btn-close-white ms-2"
              style={{ fontSize: "8px" }}
              onClick={() => removeCodeEntry(index)}
            />
          </span>
        ))}
      </div>
    </CCol>
  </CRow>
)} */}

                      <CRow className="mb-3">
                        <CCol xs="12">
                          <h6 className="mb-3">If Low</h6>
                          <hr />
                        </CCol>
                        <CCol xs="6">
                          <CFormLabel>Diagnosis</CFormLabel>
                          <Select
                            isMulti
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={allDiagnoses}
                            value={selectedDiagnosesLow}
                            onChange={setSelectedDiagnosesLow}
                          />
                        </CCol>
                      </CRow>
                      <CRow className="mb-3">
                        <CCol xs="6">
                          <CFormLabel>Remark for Assessment</CFormLabel>
                          <CFormTextarea id="remarkLow" placeholder="Enter remark for assessment" value={remarkLow} onChange={(e) => setRemarkLow(e.target.value)} />
                        </CCol>
                        <CCol xs="6">
                          <CFormLabel>Remark for Plan</CFormLabel>
                          <CFormTextarea id="remarkLowPlan" placeholder="Enter remark for plan" value={remarkLowPlan} onChange={(e) => setRemarkLowPlan(e.target.value)} />
                        </CCol>
                      </CRow>

                      <CRow className="mb-3">
                        <CCol xs="12">
                          <h6 className="mb-3">If Normal</h6>
                          <hr />
                        </CCol>
                        <CCol xs="6">
                          <CFormLabel>Diagnosis</CFormLabel>
                          <Select
                            isMulti
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={allDiagnoses}
                            value={selectedDiagnosesNormal}
                            onChange={setSelectedDiagnosesNormal}
                          />
                        </CCol>
                      </CRow>
                      <CRow className="mb-3">
                        <CCol xs="6">
                          <CFormLabel>Remark for Assessment</CFormLabel>
                          <CFormTextarea id="remarkNormal" placeholder="Enter remark for assessment" value={remarkNormal} onChange={(e) => setRemarkNormal(e.target.value)} />
                        </CCol>
                        <CCol xs="6">
                          <CFormLabel>Remark for Plan</CFormLabel>
                          <CFormTextarea id="remarkNormalPlan" placeholder="Enter remark for plan" value={remarkNormalPlan} onChange={(e) => setRemarkNormalPlan(e.target.value)} />
                        </CCol>
                      </CRow>
                      <CRow className="mb-3">
                        <CCol xs="12">
                          <h6 className="mb-3">If High</h6>
                          <hr />
                        </CCol>
                        <CCol xs="6">
                          <CFormLabel>Diagnosis</CFormLabel>
                          <Select
                            isMulti
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={allDiagnoses}
                            value={selectedDiagnosesHigh}
                            onChange={setSelectedDiagnosesHigh}
                          />
                        </CCol>
                      </CRow>
                      <CRow className="mb-3">
                        <CCol xs="6">
                          <CFormLabel>Remark for Assessment</CFormLabel>
                          <CFormTextarea id="remarkHigh" placeholder="Enter remark for assessment" value={remarkHigh} onChange={(e) => setRemarkHigh(e.target.value)} />
                        </CCol>
                        <CCol xs="6">
                          <CFormLabel>Remark for Plan</CFormLabel>
                          <CFormTextarea id="remarkHighPlan" placeholder="Enter remark for plan" value={remarkHighPlan} onChange={(e) => setRemarkHighPlan(e.target.value)} />
                        </CCol>
                      </CRow>
                    </div>
                  </CTabPane>
                  {/* <CTabPane visible={activeTab === 1}>
                  <CRow>
                    <CCol className="d-flex justify-content-center" style={{ marginTop: '-40px' }}>
                      <div className="w-75 px-3">

                        <CCard className="" style={{ border: 'none' }} >
                          <CCardBody className="  ">
                            <CButton
                              className=""
                              color="primary"
                              variant="outline"
                              onClick={addNewDiagnosis}
                            // style={{
                            //   backgroundColor: '#f8f9fa',
                            //   borderColor: '#007bff',
                            //   color: '#007bff'
                            // }}
                            >
                              + Add Reason
                            </CButton>
                          </CCardBody>
                        </CCard>

                        <div className="overflow-auto  mx-auto   px-3" style={{ height: '400px', maxWidth: '700px', marginTop: '-30px' }}>
                          {reasonList.map((item, index) => (
                            <div
                              key={index}
                              className="p-3  border rounded bg-white shadow-sm my-3 position-relative"
                              style={{
                                borderLeft: '5px solid #007bff',
                                borderRadius: '8px',
                                boxShadow: '0 4px 12px rgba(0, 123, 255, 0.1)',
                              }}
                            >
                              <div className="d-flex justify-content-end align-items-center mb-2">
                                <CButton
                                  variant="outline"
                                  color="danger"
                                  size="sm"
                                  onClick={() => removeDiagnosis(index)}
                                  className="position-absolute top-0 end-0 m-2"
                                  style={{ boxShadow: 'none' }}
                                >
                                  <Trash2 size={18} />
                                </CButton>
                              </div>

                              <CFormLabel className="  fw-bold">Select Diagnosis</CFormLabel>
                              <Select
                                isMulti
                                className="basic-multi-select"
                                placeholder="Select Diagnosis"
                                options={allDiagnoses}
                                value={item.diagnosis}
                                onChange={(selectedOption) => handleDiagnosisChange(index, selectedOption)}
                                classNamePrefix="select"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    // borderColor: '#007bff',
                                    boxShadow: 'none',
                                  }),
                                }}
                              />

                              <div className="mt-4">
                                <ReasonSuggestion
                                  label={`Reason for Diagnosis`}
                                  keywords={item.reason}
                                  setKeywords={(newReason) => handleReasonChange(index, newReason)}
                                />
                              </div>
                            </div>
                          ))}
                        </div>

                      </div>
                    </CCol>

                  </CRow>

                </CTabPane> */}
                  <CTabPane visible={activeTab === 2}>
                    <div className="d-flex   gap-2  mt-3 mx-5">
                      <CloudinaryUploader filesAl={labImageName && labImageName.length > 0 ? labImageName : file} onDelete={handleDeleteFile} onUploadSuccess={handleCloudinaryUpload} showStyleButton={true} />
                      <div className="d-flex flex-wrap gap-3">
                        {file.map((file, fileIdx) => {
                          const fileUrl = file.uploaded ? file.url : file.preview || file.url
                          const fileType = file.type || ''
                          const extension = fileUrl.split('.').pop().toLowerCase()

                          return (
                            <div key={fileIdx} className="d-flex flex-column align-items-center text-center">
                              {fileType === 'image' ? (
                                <div
                                  style={{
                                    position: 'relative',
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '4px',
                                    overflow: 'hidden',
                                  }}
                                  className="shadow border"
                                >
                                  <img
                                    src={fileUrl}
                                    alt={file.fileName || 'Preview'}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                    }}
                                  />

                                  <div
                                    style={{
                                      position: 'absolute',
                                      top: '4px',
                                      right: '4px',
                                      display: 'flex',
                                      gap: '6px',
                                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                      borderRadius: '4px',
                                      padding: '2px',
                                    }}
                                  >
                                    {/* <Pencil
                                                     className="cursor-pointer text-primary"
                                                     size={15}
                                                     onClick={() => handleEditFileData(entry.id)}
                                                   />
                            <Trash
                                                     className="cursor-pointer text-danger"
                                                     size={15}
                                                     onClick={() => handleDeleteFileData(entry.id)}
                                                     style ={{cursor: "pointer"}}
                                                   /> */}
                                  </div>
                                </div>
                              ) : fileType === 'video' || ['mp4', 'webm', 'ogg'].includes(extension) ? (
                                <div
                                  style={{
                                    position: 'relative',
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '4px',
                                    overflow: 'hidden',
                                    pointer: 'cursor',
                                  }}
                                  className="shadow border"
                                >
                                  {/* Video */}
                                  <video
                                    src={fileUrl}
                                    controls
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                    }}
                                  />

                                  {/* Action buttons */}
                                  <div
                                    style={{
                                      position: 'absolute',
                                      top: '4px',
                                      right: '4px',
                                      display: 'flex',
                                      gap: '6px',
                                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                      borderRadius: '4px',
                                      padding: '2px',
                                    }}
                                  >
                                    {/* <Pencil
                                                       className="cursor-pointer text-primary"
                                                       size={15}
                                                       onClick={() => handleEditFileData(entry.id)}
                                                     />
                            <Trash
                                                       className="cursor-pointer text-danger"
                                                       size={15}
                                                       onClick={() => handleDeleteFileData(entry.id)}
                                                       style={{ cursor: "pointer" }}
                                                     /> */}
                                  </div>
                                </div>
                              ) : ['pdf', 'doc', 'docx'].includes(extension) ? (
                                <div
                                  style={{
                                    position: 'relative',
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '4px',
                                    overflow: 'hidden',
                                    background: '#f8f9fa',
                                  }}
                                  className="d-flex align-items-center justify-content-center border shadow"
                                >
                                  {/* File Icon & Extension */}
                                  <a
                                    href={fileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      textDecoration: 'none',
                                      color: 'inherit',
                                    }}
                                    className="d-flex align-items-center justify-content-center flex-column"
                                  >
                                    <i className="bi bi-file-earmark-text" style={{ fontSize: '24px' }}></i>
                                    <p className="small m-0">{extension.toUpperCase()}</p>
                                  </a>

                                  {/* Action buttons */}
                                  <div
                                    style={{
                                      position: 'absolute',
                                      top: '4px',
                                      right: '4px',
                                      display: 'flex',
                                      gap: '6px',
                                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                      borderRadius: '4px',
                                      padding: '2px',
                                    }}
                                  >
                                    {/* <Pencil
                                                         className="cursor-pointer text-primary"
                                                         size={15}
                                                         onClick={() => handleEditFileData(entry.id)}
                                                       />
                            <Trash
                                                         className="cursor-pointer text-danger"
                                                         size={15}
                                                         onClick={() => handleDeleteFileData(entry.id)}
                                                         style={{ cursor: "delete"}}
                                                       /> */}
                                  </div>
                                </div>
                              ) : (
                                <a
                                  href={fileUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    width: '100px',
                                    height: '100px',
                                    borderRadius: '4px',
                                    background: '#e0e0e0',
                                  }}
                                  className="d-flex align-items-center justify-content-center border"
                                >
                                  <div>
                                    <i className="bi bi-file-earmark" style={{ fontSize: '24px' }}></i>
                                    <p className="small m-0">File</p>
                                  </div>
                                </a>
                              )}
                              <div
                                style={{
                                  width: '100px',
                                  height: '20px',
                                  overflow: 'auto',
                                  marginTop: '5px',
                                }}
                              >
                                <a
                                  href={file.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-dark"
                                  style={{
                                    display: 'inline-block',
                                    padding: '2px 5px',
                                    backgroundColor: '#f0f0f0',
                                    borderRadius: '4px',
                                    fontSize: '0.75rem',
                                    fontWeight: 'bold',
                                    textDecoration: 'none',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s ease',
                                  }}
                                  onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                  onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
                                >
                                  {file.fileName || 'File'}
                                </a>
                              </div>
                              {/* <small className="mt-1 text-truncate" style={{ maxWidth: "100px" }}>
                        {file.fileName}
                      </small> */}
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </CTabPane>
                </CTabContent>
              </CForm>
            </CModalBody>
            <CModalFooter>
              <CButton className="ui-action-btn ui-action-btn--primary" onClick={handleSaveLab}>
                {isLoading ? (
                  <CSpinner component="span" size="sm" aria-label="Saving" />
                ) : editIndex !== null ? (
                  'Save Changes'
                ) : (
                  'Add Lab'
                )}
              </CButton>
              <CButton color="secondary" className="ui-action-btn ui-action-btn--secondary" onClick={() => setModalVisible(false)}>
                Close
              </CButton>
            </CModalFooter>
          </CModal>

          {/* delete modal */}
          <CModal className="patient-theme-modal" visible={deleteVisibleId}>
            <CModalHeader>
              <CModalTitle>Warning</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
            </CModalBody>
            <hr className="p-0 m-0" />
            <CModalFooter className="p-3 m-0">
              <CButton
                color="secondary"
                onClick={() => {
                  setDeleteVisibleId(null)
                }}
                className="ui-action-btn ui-action-btn--secondary"
              >
                Close
              </CButton>
              <CButton color="danger" onClick={handleDeleteLab} className="ui-action-btn ui-action-btn--danger">
                Delete Lab
              </CButton>
            </CModalFooter>
          </CModal>
          <Pageloader isLoading={isPageLoading} />
        </div>
      </div>
    </>
  )
}

export default LabMaster
